var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoAdd(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "ico-add",
    d: "M8.323-11.375a2.483,2.483,0,0,1,2.483,2.483v4.966A2.483,2.483,0,0,1,8.323-1.444H3.358A2.483,2.483,0,0,1,.875-3.927V-8.892a2.483,2.483,0,0,1,2.483-2.483Zm0,2.483H3.358v4.966H8.323Zm0,10.759a2.483,2.483,0,0,1,2.483,2.483V9.315A2.483,2.483,0,0,1,8.323,11.8H3.358A2.483,2.483,0,0,1,.875,9.315V4.349A2.483,2.483,0,0,1,3.358,1.866Zm0,2.483H3.358V9.315H8.323ZM14.116-8.892A2.483,2.483,0,0,1,16.6-11.375h4.966a2.483,2.483,0,0,1,2.483,2.483v4.966a2.483,2.483,0,0,1-2.483,2.483H16.6a2.483,2.483,0,0,1-2.483-2.483ZM16.6-3.927h4.966V-8.892H16.6Zm2.483,4.966A1.238,1.238,0,0,1,20.323,2.28v3.31h3.31a1.241,1.241,0,1,1,0,2.483h-3.31v3.31a1.241,1.241,0,1,1-2.483,0V8.073H14.53a1.241,1.241,0,0,1,0-2.483h3.31V2.28A1.238,1.238,0,0,1,19.082,1.039Z",
    transform: "translate(-0.875 11.375)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoAdd);
export default __webpack_public_path__ + "static/media/ico-add.3296c8eb7a8ec217d391d984ac71cbd4.svg";
export { ForwardRef as ReactComponent };